<template>
  <div>
    <intro></intro>
    <offer></offer>
    <plasma></plasma>
  </div>
</template>

<script>
import Intro from './components/Intro';
import Offer from './components/Offer';
import Plasma from './components/Plasma';

export default {
  name: 'landing',
  components: {
    Intro,
    Offer,
    Plasma,
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// Landing.vue?2b12e2ac